import type { Showcase } from './api';
import { BOT_OPERATION, BOT_OPTION_TYPE, type BotFlowState } from './types';

export const MAIN_MENU_REF = 'MENU_PRINCIPAL';
export const CATEGORY_MENU_REF = 'ESCOLHER_CATEGORIA';

/**
 * O menu do bot nasce dos cadastros reais: as categorias do salao viram as
 * opcoes de escolha, e os servicos de cada uma alimentam a jornada.
 */
export function buildBotFlow(showcase: Showcase | undefined): BotFlowState {
  const categories = showcase?.categories ?? [];

  return {
    initialMenuRef: MAIN_MENU_REF,
    menus: [
      {
        ref: MAIN_MENU_REF,
        question: 'Ola! O que deseja?',
        options: [
          {
            label: 'Agendar Atendimento',
            type: BOT_OPTION_TYPE.SUBMENU,
            nextMenuRef: CATEGORY_MENU_REF,
            operation: null,
          },
          {
            label: 'Ver lista de servicos',
            type: BOT_OPTION_TYPE.OPERATION,
            nextMenuRef: null,
            operation: BOT_OPERATION.LIST_ALL_SERVICES,
            categoryId: null,
          },
          {
            label: 'Cancelar meu agendamento',
            type: BOT_OPTION_TYPE.OPERATION,
            nextMenuRef: null,
            operation: BOT_OPERATION.CANCEL_SCHEDULING,
          },
        ],
      },
      {
        ref: CATEGORY_MENU_REF,
        question: 'Escolha a categoria do servico',
        options: [
          ...categories.map((category) => ({
            label: category.name,
            type: BOT_OPTION_TYPE.OPERATION,
            nextMenuRef: null,
            operation: BOT_OPERATION.LIST_CATEGORY_SERVICES,
            categoryId: category.id,
          })),
          {
            label: 'Quero ver todos',
            type: BOT_OPTION_TYPE.OPERATION,
            nextMenuRef: null,
            operation: BOT_OPERATION.LIST_ALL_SERVICES,
            categoryId: null,
          },
        ],
      },
    ],
  };
}
